import React, {useState, useEffect} from 'react';
import '../style/tours.css';

export default function Tours(props) {
  const tours = [
    {date: '01/06/2024', duration: '1 week', address: 'Place de Thessalie', town: 'Montpellier', mapLink: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2888.933168988845!2d3.8915423!3d43.6079331!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x12b6afc1d71b1ead%3A0x13c7cdb9dcf20a22!2sPlace%20de%20Thessalie!5e0!3m2!1sfr!2sfr!4v1715111237591!5m2!1sfr!2sfr'},
    {date: '29/06/2024', duration: '2 days', address: 'Place des Quinconces', town: 'Bordeaux', mapLink: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2828.82123253582!2d-0.57332545!3d44.84557385!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd5527d9e0afbdd7%3A0xa4ca8bd6847a029b!2sPlace%20des%20Quinconces%2C%2033000%20Bordeaux!5e0!3m2!1sfr!2sfr!4v1715111524446!5m2!1sfr!2sfr'},
    {date: '13/07/2024', duration: '1 week', address: 'Place Graslin', town: 'Nantes', mapLink: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2710.1819419758053!2d-1.5623707000000002!3d47.2130222!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4805ec02d3d8ae9f%3A0xc84bbfe58fd0936e!2sPl.%20Graslin%2C%2044036%20Nantes!5e0!3m2!1sfr!2sfr!4v1715111807685!5m2!1sfr!2sfr'},
    {date: '27/07/2024', duration: '1 week', address: 'Place de la république', town: 'Lille', mapLink: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d5061.536161168913!2d3.0610565999999997!3d50.631425!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47c2d585767f73a5%3A0xb620054cd098f54a!2sPlace%20de%20la%20R%C3%A9publique!5e0!3m2!1sfr!2sfr!4v1715111842918!5m2!1sfr!2sfr'},
    {date: '10/08/2024', duration: '1 week', address: 'Place Gutenberg', town: 'Strasbourg', mapLink: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2639.494330698383!2d7.7481688!3d48.5812331!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4796c8528cf83603%3A0xa3705ad5e5de8630!2sPl.%20Gutenberg%2C%2067000%20Strasbourg!5e0!3m2!1sfr!2sfr!4v1715111880125!5m2!1sfr!2sfr'},
    {date: '24/08/2024', duration: '1 week', address: 'Place Bellecour', town: 'Lyon', mapLink: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2783.6707643623968!2d4.8321483999999995!3d45.757746!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47f4ea537bdc5ab3%3A0x5d9d9385f58b2047!2sPlace%20Bellecour!5e0!3m2!1sfr!2sfr!4v1715111930514!5m2!1sfr!2sfr'},
  ];
  const [tour, setTour] = useState(false)
  const showTour = () => {

  };
  useEffect(() => {
    // setTour(false);

    return;
  }, [])
  return (
    <div style={{marginTop: '30px'}}>
      <div>
        <h2>Follow my tours, see you soon in your city</h2>
      </div>
      <div className="tours_container noselect">
        <ul className="tours_list">
          {tours.map((tr, index) => (
            <li
              key={'tr' + index}
              className="oneTour"
              onClick={() => {
                setTour(tr);
                // setTimeout(() => document.querySelector('.tour_content').style.animation = 'showTour 0.6s linear', 100);
                }}>
              <span style={{fontSize: '20px', fontWeight: '500'}}>{tr.date}</span>
              <span style={{padding: '0 8px'}}> - </span>
              <span style={{fontSize: '18px', fontWeight: '400'}}>{tr.town}</span>
              <span style={{padding: '0 4px 0 28px', color: 'magenta'}}>
                <img src={process.env.PUBLIC_URL + '/icons/show_details.png'} width="40" height="40" />
              </span>
            </li>
          ))}
        </ul>
      </div>
      {tour && (
        <div className="tour_container">
          <div className="tour_content">
            <div
              className="hideTourDetail"
              onClick={() => {
                document.querySelector('.tour_content').style.animation = 'hideTour 0.4s linear';
                setTimeout(() => setTour(), 400);
                }}>
              <img
                className="add_comment"
                src={process.env.PUBLIC_URL + '/icons/go_back_70x70.ico'}
                width="50"
                height="50"
                alt="go back" />
            </div>
            <div style={{position: 'relative', top: '30px'}}>
              <span style={{fontSize: '20px', fontWeight: '500'}}>{tour.date}</span>
              <span style={{padding: '0 8px'}}> - </span>
              <span style={{fontSize: '18px', fontWeight: '400'}}>{tour.town}</span>
              <span style={{padding: '0 8px'}}> - </span>
              <span style={{fontSize: '18px', fontWeight: '400'}}>{tour.address}</span>
            </div>
            <div>
              <iframe
                className="insertionMaps"
                allowFullScreen="1"
                src={tour.mapLink}
                referrer="no-referrer-when-downgrade"></iframe>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
